import { CrossingSeries, PresenceSeriesParams } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
import { seriesQueryString } from './seriesQuery';

/** Crossings of a line over time. The zone must be a line; the API refuses an area. */
export function useZoneCrossings(
  zoneId: string,
  params: PresenceSeriesParams = {},
  enabled = true
) {
  const query = seriesQueryString(params);
  const url = `/v2/orm/presence/zones/${zoneId}/crossings${query}`;
  const request = new Request(url);

  return useAuthenticatedRequest<CrossingSeries>(request, {
    queryKey: ['presence-crossings', zoneId, query],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    staleTime: 60 * 1000,
    enabled,
  });
}

export default useZoneCrossings;
